import type { ICommunityWorldMapCountry } from "./types";

interface WorldMapCountryCardProps {
  country: ICommunityWorldMapCountry;
  localTime: string;
  utcLabel: string;
  localTimeLabel?: string;
  onFloorLabel?: string;
  floorCapacity?: number;
}

export default function WorldMapCountryCard({
  country,
  localTime,
  utcLabel,
  localTimeLabel,
  onFloorLabel,
  floorCapacity,
}: WorldMapCountryCardProps) {
  const progress = floorCapacity
    ? Math.min((country.onFloor / floorCapacity) * 100, 100)
    : 0;

  return (
    <div
      data-world-map-card
      className="w-[28.75rem] origin-top-left rounded-[1.5rem] border border-[rgba(255,255,255,0.12)] bg-[#131313] px-[2.625rem] pt-[2.375rem] pb-[2.625rem] text-left [--world-map-card-scale:1.09365] lg:[--world-map-card-scale:1.41898]"
      style={{ transform: "scale(var(--world-map-card-scale))" }}>
      <div className="flex items-start gap-[2rem]">
        <p className="m-0 min-w-0 flex-1 font-geist text-[2rem] leading-[2.75rem] font-medium tracking-[-0.02rem] text-white">
          {country.name}
        </p>
        <p className="m-0 shrink-0 font-geist text-[1.75rem] leading-[2.5rem] text-white/[0.36]">
          {utcLabel}
        </p>
      </div>
      <p
        suppressHydrationWarning
        className="mt-[1.625rem] mb-0 font-geist text-[4.625rem] leading-[4.625rem] font-light tracking-[-0.2075rem] text-[#98d8ff]">
        {localTime}
      </p>
      <p className="mt-[1.75rem] mb-0 font-geist text-[1.75rem] leading-[2.5rem] text-white/[0.42]">
        {localTimeLabel}
      </p>
      <div className="mt-[1.875rem] h-px w-full bg-white/10" />
      <div className="mt-[1.75rem] flex items-baseline gap-[1.875rem]">
        <p className="m-0 min-w-0 flex-1 font-geist text-[1.75rem] leading-[2.5rem] text-white/[0.42]">
          {onFloorLabel}
        </p>
        <p className="m-0 shrink-0 font-geist text-[2rem] leading-[2.75rem] font-medium text-white">
          {country.onFloor}
        </p>
      </div>
      <div className="mt-[1.375rem] h-[0.5rem] w-full overflow-hidden rounded-[0.25rem] bg-white/10">
        <div
          className="h-full rounded-[0.25rem] bg-[#98d8ff]"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
